import request from '@/utils/request'

/**
 * 获取项目列表
 * @param param
 */
export function fetchList(query) {
    return request({
        url: '/api/rep/model/post/list',
        method: 'post',
        data:query
    })
}

/**
 * 通过行业获取岗位
 * @param param
 */
export function fetchByCategoryId(cid) {
    return request({
        url: '/api/rep/model/post/category/list/'+cid,
        method: 'get',
    })
}

/**
 * 通过客户获取岗位
 * @param param
 */
export function findByCustomer(customerId) {
    return request({
        url: '/api/rep/model/post/customer/list/'+customerId,
        method: 'get',
    })
}

/**
 * 获取项目列表
 * @param param
 */
export function fetchPost() {
    return request({
        url: '/api/rep/model/post/all',
        method: 'post',
    })
}

/**
 * 新增公告
 * @param param
 */
export function save(query) {
    return request({
        url: '/api/rep/model/post/save',
        method: 'post',
        data: query
    })
}

/**
 * 修改公告
 * @param param
 */
export function update(query) {
    return request({
        url: '/api/rep/model/post/update',
        method: 'post',
        data: query
    })
}

/**
 * 获取公告
 * @param param
 */
export function get(id) {
    return request({
        url: '/api/rep/model/post/get/' + id,
        method: 'get'
    })
}

/**
 * 删除公告
 * @param param
 */
export function remove(id) {
    return request({
        url: '/api/rep/model/post/delete/' + id,
        method: 'post'
    })
}


